import React from "react";

const Manual = () => {
  const fileList = [
    {
      label: "คู่มือการฝึกงานสำหรับภาคฤดูร้อน",
      path: "./assets/file/manual/ENGBUU-internMiniHandbook.pdf",
    },
    {
      label: "ปฏิทินการฝึกงานปีการศึกษา ภาคฤดูร้อน 2565",
      path: "./assets/file/manual/ENGBUU-interncalendar1.pdf",
    },

    {
      label: "แบบบันทึกการฝึกงาน (Logbook) และ รายงานความก้าวหน้า (Progress Report) แบบ pdf ",
      path: "https://eng.buu.ac.th/internship/documents/doc2.pdf",
    },

    {
      label: "แบบบันทึกการฝึกงาน (Logbook) และ รายงานความก้าวหน้า (Progress Report)แบบ word ",
      path: "https://eng.buu.ac.th/internship/documents/doc5.docx",
    },

    {
      label: "ตัวอย่างแบบแจ้งรายละเอียดการปฏิบัติงาน แผนที่ตั้งสถานประกอบการ (ตอนส่งจะให้ส่งผ่านแบบฟอร์มออนไลน์)",
      path: "./assets/file/manual/ENG-Coop S004.pdf",
    },

    {
      label: "ตัวอย่างแบบรรายงานฝึกงาน (Final Report) ",
      path: "./assets/file/manual/Templete_Final Report ENGBUU-66.docx",
    },

    {
      label: "ตัวอย่างแบบประเมินนิสิตฝึกงาน",
      path: "./assets/file/manual/ENGBUU-internship_as_form.pdf",
    },
    {
      label: "ตัวอย่างใบลา",
      path: "./assets/file/manual/ใบลา.doc",
    },
    {
      label: "ตัวอย่างใบลา กรณี ประสบอุบัติเหตุ.doc",
      path: "./assets/file/manual/ใบลา กรณี ประสบอุบัติเหตุ.doc",
    },

    {
      label: "ประกาศการเบิกค่ารักษาพยาบาล กรณี เกิดอุบัติเหตุ",
      path: "./assets/file/manual/ประกาศการเบิกค่ารักษาพยาบาล กรณี เกิดอุบัติเหตุ.pdf",
    },

  ];

  return (
    <div>
      <h3>เอกสารที่ใช้การฝึกงานภาคฤดูร้อน</h3>
      <ul>
        {fileList?.map((file) => {
          return (
             <li>
              <a href={file.path} target="_blank">
                {file.label}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Manual;
